import {
  dispatchAsync, dispatchSync
} from '../utils/vuex'

export default {
  // account
  readAccount: dispatchAsync('account/read'),
  loadAccount: dispatchAsync('account/load'),
  readMyUid: dispatchAsync('account/readUid'),
  loadMyUid: dispatchAsync('account/loadUid'),

  // router
  goLogin: dispatchSync('router/goLogin'),
  goLogout: dispatchSync('router/goLogout'),
  goRegister: dispatchSync('router/goRegister'),
  goRealname: dispatchSync('router/goRealname'),
  

  // nav
  navBack: dispatchSync('nav/back'),
}
